import { reactive } from "https://unpkg.com/petite-vue@0.2.2/dist/petite-vue.es.js";

const cart = reactive({
  items: [],
  loading: false,
  item_count: 0,
  total_price: 0,
  open: true,
});

const selectedVariantRef = reactive({});

const useCart = (cartSerialized) => {
  Object.assign(cart, cartSerialized || "{}");

  const emitEvent = (event, data = {}) => {
    window.dispatchEvent(new CustomEvent(event, { detail: data }));
  };

  const refreshItems = async () => {
    cart.loading = true;
    let res = await fetch("/cart.js", { method: "GET" });

    res = await res.json();
    Object.assign(cart, res);

    cart.loading = false;
  };

  const addVariantToCart = async (id, quantity = 1) => {
    cart.loading = true;
    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id,
            quantity,
          },
        ],
      }),
    });

    await refreshItems();

    emitEvent("cartchanged", {
      type: "add",
      id,
      quantity,
    });
  };

  const updateVariantCartQuantity = async (id, quantity) => {
    const updates = {};
    updates[id] = quantity;

    cart.loading = true;
    await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates,
      }),
    });

    await refreshItems();

    emitEvent("cartchanged", {
      type: "updated",
      id,
      quantity,
    });
  };

  const removeVariantFromCart = async (id) => {
    const updates = {};
    updates[id] = 0;

    cart.loading = true;
    await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates,
        sections: "cart-complementary-products",
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (!response.sections["cart-complementary-products"]) return;
        // cart.complementary_products =
        //   response.sections["cart-complementary-products"];
        // window.dispatchEvent(
        //   new CustomEvent("cartupdated", { detail: response })
        // );
        window.dispatchEvent(
          new CustomEvent("complementaryproductschanged", {
            detail: response.sections["cart-complementary-products"],
          })
        );
      });

    await refreshItems();

    emitEvent("cartchanged", {
      type: "removed",
      id,
    });
  };

  return {
    cart,
    selectedVariantRef,
    refreshItems,
    addVariantToCart,
    updateVariantCartQuantity,
    removeVariantFromCart,
  };
};

const initCartFns = (parent = null) => {
  // Add to Cart
  const addToCartForms = parent
    ? parent.querySelectorAll("form")
    : document.querySelectorAll('form[action$="/cart/add"]');

  for (const form of addToCartForms) {
    // Return if already activated
    if (form.dataset.actived) return;
    form.dataset.actived = "true";

    // Return if STL form
    if (form.classList.contains(".product-form--stl")) return;

    const submitBtn = form.querySelector('[type="button"]');
    const inputIds = form.querySelectorAll("[name^=id]");

    submitBtn.addEventListener("click", (e) => {
      e.preventDefault();

      // Un-disable fields and set up loading state
      inputIds.forEach((input) => (input.disabled = false));
      submitBtn.setAttribute("aria-disabled", true);
      submitBtn.classList.add("loading");

      // Get form data
      // let formData = new FormData(form);

      let items = [];
      inputIds.forEach((i) => {
        const item = { id: i.value, quantity: 1 };
        if (i.dataset.preorder == "true") item.properties = { preorder: true };
        items.push(item);
      });

      let data = {
        items,
        sections: "cart-complementary-products",
      };

      // Send data
      fetch(`${routes.cart_add_url}.js`, {
        method: "POST",
        headers: {
          "Content-Type": `application/json`,
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((response) => {
          window.dispatchEvent(
            new CustomEvent("cartupdated", { detail: response })
          );

          // Complementary products change
          if (!response.sections["cart-complementary-products"]) return;
          window.dispatchEvent(
            new CustomEvent("complementaryproductschanged", {
              detail: response.sections["cart-complementary-products"],
            })
          );
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .finally(() => {
          submitBtn.classList.remove("loading");
          submitBtn.removeAttribute("aria-disabled");
        });
    });
  }
};

// Currency formatting
const formatMoney = (cents, format) => {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  const placeholderRegex = /\{\s*(\w+)\s*\}/;
  const formatString = format || `${amount}`;

  function formatWithDelimiters(number, precision = 2) {
    const thousands = ",";
    const decimal = ".";
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2).replace(/[.,]00$/, "");
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2).replace(/\./, ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0).replace(/\./, ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

export { useCart, initCartFns, formatMoney };
